// extracted by mini-css-extract-plugin
export default {"wrapper":"fallback_wrapper__uMknT"};